import { useQuery, useSuspenseQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { buildingInfoSchema } from '../../../common/validations'
import { API_ENDPOINTS } from '../../../common/apiEndpoints'

import { get } from 'api/apiClient'
import { Language } from 'i18n/i18n'

const params = (contractUuid: string, lang: Language) => {
  const path = API_ENDPOINTS.BUILDING_INFO.replace(
    ':contractUuid',
    contractUuid
  )

  return {
    cacheTime: 59000,
    queryKey: ['buildingInfo', contractUuid, lang],
    queryFn: async () => {
      return get(path, buildingInfoSchema)
    },
  }
}

export const useAPIGetBuildingInfo = (contractUuid: string) => {
  const {
    i18n: { language },
  } = useTranslation()

  return useQuery(params(contractUuid, language as Language))
}

export const useAPIGetBuildingInfoSuspense = (contractUuid: string) => {
  const {
    i18n: { language },
  } = useTranslation()

  return useSuspenseQuery(params(contractUuid, language as Language))
}
